import { Box, Typography } from '@mui/material'
import React from 'react'
import AttestationCard from './AttestationCard'
import { TICKERS } from '@/constants/token'
import { useAllTokenPrice } from '@/hooks/useTokenPrice'

const Attestation = () => {
  const { data: prices } = useAllTokenPrice()

  return (
    <Box>
      <Typography variant="h1" sx={{ textShadow: '0px 0px 40px #bfff0b', fontSize: '36px', fontWeight: 400 }}>
        Attestation
      </Typography>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: {
            xs: 'auto',
            sm: 'repeat(2, minmax(300px, 1fr) )',
            md: 'repeat(3, minmax(300px, 1fr) )',
          },
          gap: 24,
          mt: 24,
        }}
      >
        {TICKERS.map((ticker) => (
          <AttestationCard key={ticker.name} ticker={ticker} price={prices?.[ticker?.priceInfo?.id]} />
        ))}
      </Box>
    </Box>
  )
}

export default Attestation
